import { getStoredAuthToken, removeAuthToken } from "./authTokenStorage";

const productionApiBaseUrl = "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/";
const localApiBaseUrl = "http://localhost:3001/";

function normalizeBaseUrl(url) {
  return url.endsWith("/") ? url : `${url}/`;
}

export const baseUrl = normalizeBaseUrl(
  process.env.API_BASE_URL || (process.env.NODE_ENV === "production" ? productionApiBaseUrl : localApiBaseUrl),
);

function getStoredToken() {
  return getStoredAuthToken();
}

export function authHeaders(headers = {}) {
  const token = getStoredToken();

  if (!token) {
    return headers;
  }

  return {
    ...headers,
    Authorization: `Bearer ${token}`,
  };
}

export async function handleResponse(response, notifyAccessChange = true) {
  if (response.ok) {
    if (response.status === 204) return null;
    if (typeof response.text === "function") {
      const body = await response.text();
      if (!body) return null;
      return JSON.parse(body);
    }
    return response.json();
  }
  if (response.status === 401) {
    removeAuthToken();
    throw new Error("Unauthorized");
  }
  if (response.status === 400) {
    // So, a server-side validation error occurred.
    // Server side validation returns a string error message, so parse as text instead of json.
    const error = await response.text();
    throw new Error(error);
  }
  if (response.status === 403) {
    const error = await response.text();
    let message = error || "Forbidden";
    try {
      const parsed = JSON.parse(error);
      message = parsed.error || parsed.message || message;
    } catch (parseError) {
      if (!parseError) message = error;
      // Keep plain text permission responses as-is.
    }
    const forbiddenError = new Error(message === "Forbidden" ? "Brak uprawnien" : message);
    forbiddenError.code = 403;
    if (notifyAccessChange && typeof window !== 'undefined') window.dispatchEvent(new Event('teacher-access-denied'));
    throw forbiddenError;
  }
  const error = await response.text();
  if (response.status === 409) {
    let message = error;
    try {
      const parsed = JSON.parse(error);
      message = parsed.error || parsed.message || error;
    } catch (parseError) {
      // Plain text conflict responses remain readable by the application translator.
    }
    throw Object.assign(new Error(message), { code: 409 });
  }
  const responseError = new Error(`Network response was not ok. status:${response.status} error:${error}`);
  responseError.code = response.status;
  throw responseError;
}

// In a real app, would likely call an error logging service.
export function handleError(error) {
  // eslint-disable-next-line no-console
  console.error(`API call failed. ${error}`);
  throw error;
}
